module.exports = __webpack_public_path__ + "img/left_arrow.b14c19fa.svg";